<template>
  <div class="register-modal" v-if="visible">
    <div class="register-box">
      <button class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </button>
      
      <div class="register-header">
        <img src="@/assets/jenkins.png" alt="Logo" class="logo" />
        <h2>用户注册</h2>
      </div>

      <el-form :model="form" :rules="rules" ref="registerForm" class="register-form" autocomplete="off">
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入邮箱账号"
            prefix-icon="el-icon-user"
            size="large"
            autocomplete="new-username"
          ></el-input>
        </el-form-item>

        <el-form-item prop="sources">
          <el-select
            v-model="form.sources"
            placeholder="请选择来源渠道"
            size="large"
            style="width: 100%"
          >
            <el-option label="B站" value="B站"></el-option>
            <el-option label="小红书" value="小红书"></el-option>
            <el-option label="抖音" value="抖音"></el-option>
            <el-option label="朋友推荐" value="朋友推荐"></el-option>
            <el-option label="搜索引擎" value="搜索引擎"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码（至少6位）"
            prefix-icon="el-icon-lock"
            size="large"
            show-password
            autocomplete="new-password"
          ></el-input>
        </el-form-item>

        <el-form-item prop="confirmPassword">
          <el-input
            v-model="form.confirmPassword"
            type="password"
            placeholder="请确认密码"
            prefix-icon="el-icon-lock"
            size="large"
            show-password
            autocomplete="new-password"
          ></el-input>
        </el-form-item>

        <el-form-item prop="captchaCode">
          <el-input
            v-model="form.captchaCode"
            placeholder="请输入图形验证码"
            prefix-icon="el-icon-picture"
            size="large"
            autocomplete="off"
          >
            <template slot="append">
              <div class="captcha-container" @click="refreshCaptcha">
                <span v-if="captchaLoading">加载中...</span>
                <span v-else class="captcha-code">{{ captchaValue }}</span>
                <i class="el-icon-refresh captcha-refresh"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item prop="emailCode">
          <el-input
            v-model="form.emailCode"
            placeholder="请输入邮箱验证码"
            prefix-icon="el-icon-key"
            size="large"
            autocomplete="off"
          >
            <el-button
              slot="append"
              :disabled="countdown > 0 || !isCaptchaValid"
              @click="sendCode"
              :loading="sending"
            >
              {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
            </el-button>
          </el-input>
        </el-form-item>

        <el-button
          type="primary"
          class="register-btn"
          @click="handleRegister"
          :loading="loading"
        >
          注册
        </el-button>

        <div class="register-footer">
          <span>已有账号？</span>
          <a @click="goToLogin">立即登录</a>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码至少6位'))
      } else {
        if (this.form.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      form: {
        username: '',
        sources: '',
        password: '',
        confirmPassword: '',
        captchaCode: '',
        emailCode: ''
      },
      captchaValue: '',
      captchaLoading: false,
      rules: {
        username: [
          { required: true, message: '请输入邮箱账号', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' },
          { max: 30, message: '邮箱账号最多30个字符', trigger: 'blur' }
        ],
        sources: [
          { required: true, message: '请选择来源渠道', trigger: 'change' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ],
        captchaCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' },
          { min: 4, max: 6, message: '请输入正确的验证码', trigger: 'blur' }
        ],
        emailCode: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '验证码为6位', trigger: 'blur' }
        ]
      },
      loading: false,
      sending: false,
      countdown: 0,
      timer: null
    }
  },
  computed: {
    isCaptchaValid() {
      const code = this.form.captchaCode
      const value = this.captchaValue
      if (!code || !value || typeof code !== 'string' || typeof value !== 'string') {
        return false
      }
      return code.toLowerCase() === value.toLowerCase()
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.refreshCaptcha()
        this.resetForm()
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    
    resetForm() {
      this.form = {
        username: '',
        sources: '',
        password: '',
        confirmPassword: '',
        captchaCode: '',
        emailCode: ''
      }
      if (this.$refs.registerForm) {
        this.$refs.registerForm.clearValidate()
      }
    },
    
    refreshCaptcha() {
      this.captchaLoading = true
      this.captchaValue = ''
      this.form.captchaCode = ''

      this.request.post('/user/generate_captcha').then(res => {
        if (res.code === '200') {
          this.captchaValue = res.data
        } else {
          this.$message.error('获取验证码失败')
        }
        this.captchaLoading = false
      }).catch(() => {
        this.$message.error('获取验证码失败')
        this.captchaLoading = false
      })
    },

    sendCode() {
      if (!this.form.captchaCode) {
        this.$message.error('请先输入图形验证码')
        return
      }
      const code = String(this.form.captchaCode || '')
      const value = String(this.captchaValue || '')
      if (!value || code.toLowerCase() !== value.toLowerCase()) {
        this.$message.error('图形验证码错误')
        this.refreshCaptcha()
        return
      }

      this.$refs.registerForm.validateField('username', (valid) => {
        if (!valid) {
          this.sending = true
          this.request.post('/user/send/email/code/register', null, {
            params: { email: this.form.username }
          }).then(res => {
            if (res.code === '200') {
              this.$message.success('验证码已发送到您的邮箱')
              this.countdown = 60
              this.timer = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                  clearInterval(this.timer)
                }
              }, 1000)
            } else {
              this.$message.error(res.msg || '发送失败')
            }
          }).catch(() => {
            this.$message.error('发送失败，请稍后重试')
          }).finally(() => {
            this.sending = false
          })
        }
      })
    },

    handleRegister() {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          const code = String(this.form.captchaCode || '')
          const value = String(this.captchaValue || '')
          if (!value || code.toLowerCase() !== value.toLowerCase()) {
            this.$message.error('图形验证码错误')
            this.refreshCaptcha()
            return
          }

          this.loading = true
          const registerData = {
            username: this.form.username,
            sources: this.form.sources,
            password: this.form.password,
            captchaCode: this.form.captchaCode,
            emailCode: this.form.emailCode
          }
          
          this.request.post('/user/register', registerData).then(res => {
            if (res.code === '200') {
              this.$message.success('注册成功，请登录')
              this.handleClose()
              this.$emit('register-success')
            } else {
              this.$message.error(res.msg || '注册失败')
              this.refreshCaptcha()
            }
          }).catch(() => {
            this.$message.error('注册失败，请稍后重试')
            this.refreshCaptcha()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },

    goToLogin() {
      this.handleClose()
      this.$emit('switch-to-login')
    }
  }
}
</script>

<style scoped>
.register-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.register-box {
  background: #fff;
  border-radius: 0;
  padding: 35px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 20px;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #374151;
}

.register-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-bottom: 16px;
}

.register-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.register-form {
  margin-top: 24px;
}

.register-form .el-form-item {
  margin-bottom: 20px;
}

.register-form >>> .el-input__inner {
  border-radius: 0;
}

.register-form >>> .el-select {
  width: 100%;
}

.register-form >>> .el-input-group__append {
  border-radius: 0;
}

.register-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  margin-top: 8px;
  border-radius: 0;
  background-color: #2563eb;
  border-color: #2563eb;
}

.register-btn:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

.register-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #6b7280;
}

.register-footer a {
  color: #2563eb;
  cursor: pointer;
  text-decoration: none;
  margin-left: 4px;
}

.register-footer a:hover {
  text-decoration: underline;
}

.captcha-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 120px;
  width: 120px;
  cursor: pointer;
  padding: 0;
  height: 100%;
  user-select: none;
}

.captcha-code {
  font-family: 'Courier New', Courier, monospace;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 2px;
  color: #2563eb;
}

.captcha-refresh {
  color: #9ca3af;
  font-size: 16px;
  flex-shrink: 0;
}

.captcha-container:hover .captcha-refresh {
  color: #2563eb;
}

.register-form >>> .el-input-group__append {
  width: 120px;
  padding: 0;
  text-align: center;
}

.register-form >>> .el-input-group__append .el-button {
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
}

.register-form >>> .el-input-group__append .el-button span {
  display: block;
  width: 100%;
  text-align: center;
}

@media screen and (max-width: 480px) {
  .register-box {
    padding: 24px;
  }

  .register-header h2 {
    font-size: 20px;
  }
}
</style>
